export default function PageHero({ eyebrow, title, subtitle, image, height = "h-[360px] md:h-[420px]", testId }) {
  return (
    <section
      data-testid={testId || "page-hero"}
      className={`relative w-full ${height} flex items-end`}
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 eco-hero-overlay" />
      <div className="relative eco-container pb-12 md:pb-16">
        {eyebrow && (
          <span className="inline-block text-[11px] font-semibold uppercase tracking-[0.22em] text-white/85 mb-3 eco-reveal">
            {eyebrow}
          </span>
        )}
        <h1 className="text-white text-3xl sm:text-4xl lg:text-5xl font-extrabold max-w-3xl leading-tight eco-reveal eco-reveal-d1">
          {title}
        </h1>
        {subtitle && (
          <p className="text-white/90 text-base md:text-lg max-w-2xl mt-4 eco-reveal eco-reveal-d2">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
